function changeKendoDatePicker(datepicker: kendo.ui.DatePicker | undefined, value: string) {
    const date = window.parseDate(value);

    if (date && datepicker) {
        const dateValue = datepicker.value();

        if (!dateValue || dateValue.getTime() !== date.getTime()) {
            datepicker.value(date);
            datepicker.trigger('change');
        }
    }
}

function updateDtEndForCalculationRequest(dtEnd: kendo.ui.DateTimePicker, utc: number, isSingle: boolean): void {
    if (utc === 0) {
        // Если у логиста не установлено в БД UTC, то ставим по умолчанию utc Екатеринбурга
        utc = 5;
    }

    const date = new Date();
    let warningMessage = '';
    let dtEndValue = dtEnd.value();

    if (!dtEndValue) {
        return;
    }

    const currentLogistHours = date.getUTCHours() + utc;
    const currentLogistDateTime = new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        currentLogistHours,
        date.getUTCMinutes()
    );
    const minValidDateTime = new Date(currentLogistDateTime);

    enum CalculationRequestWarningMessage {
        deliveryCalculation = 'Время дедлайна было изменено, т.к. минимальное время расчёта 24ч от текущего времени',
        singleCalculation = 'Время дедлайна было изменено, т.к. минимальное время расчёта 2ч от текущего времени',
        calculation = 'Время дедлайна было изменено, т.к. дедлайн не попадает в рабочий день логиста 09 - 18 по Екб'
    }

    if (isSingle) {
        minValidDateTime.setHours(currentLogistDateTime.getHours() + 2);
    }
    else {
        minValidDateTime.setDate(currentLogistDateTime.getDate() + 1);
    }

    if (dtEndValue.getTime() <= minValidDateTime.getTime()) {
        dtEndValue = new Date(minValidDateTime);
        dtEnd.value(new Date(dtEndValue));
        warningMessage = isSingle
            ? CalculationRequestWarningMessage.singleCalculation
            : CalculationRequestWarningMessage.deliveryCalculation;
    }

    const dtEndHours: number = dtEndValue.getUTCHours() + utc;
    const dtEndDateTime: Date = new Date(
        dtEndValue.getUTCFullYear(),
        dtEndValue.getUTCMonth(),
        dtEndValue.getUTCDate(),
        dtEndHours,
        dtEndValue.getUTCMinutes()
    );
    const day: number = dtEndDateTime.getDay();
    const { afterWork, beforeWork, isFriday, isSaturday, isSunday } = {
        afterWork: dtEndHours >= 18,
        beforeWork: (dtEndHours + dtEndDateTime.getMinutes() / 60) < 9,
        isSunday: day === 0,
        isSaturday: day === 6,
        isFriday: day === 5
    };

    function setDtEndValue(endValue: Date, daysOffset: number) {
        endValue.setDate(endValue.getDate() + daysOffset);
        endValue.setHours(10);
        endValue.setMinutes(0);
        dtEnd.value(new Date(endValue));
        warningMessage = CalculationRequestWarningMessage.calculation;
    }

    switch (true) {
        case isFriday && afterWork: {
            setDtEndValue(dtEndValue, 3);
            break;
        }
        case isSunday || afterWork: {
            setDtEndValue(dtEndValue, 1);
            break;
        }
        case isSaturday: {
            setDtEndValue(dtEndValue, 2);
            break;
        }
        case beforeWork: {
            setDtEndValue(dtEndValue, 0);
            break;
        }
    }

    if (warningMessage) {
        window.swal.fire('Внимание', warningMessage, 'warning');
    }

    dtEnd.trigger('change');
}

function validateDateInput(element: JQuery) {
    element.kendoValidator({
        validationSummary: undefined,
        rules: {
            // implement your custom date validation
            dateValidation: (input: JQuery<HTMLInputElement>) => {
                const value = input.val();

                if (value) {
                    const currentFullDate = kendo.parseDate(value, 'dd.MM.yyyy');
                    const currentSmartDate = kendo.parseDate(value, 'MMMM yyyy');
                    const currentYearDate = kendo.parseDate(value, 'yyyy');

                    if (!currentFullDate && !currentSmartDate && !currentYearDate) {
                        input.val(' ');
                        return false;
                    }
                }
                return true;
            },
            date: (input: JQuery<HTMLInputElement>) => {
                if (input.data('val-required')) {
                    return input.val();
                }

                return true;
            }
        },
        messages: {
            // Define your custom validation massages
            dateValidation: 'Неверная дата',
            date: (input: JQuery<HTMLInputElement>) => {
                return input.data('val-required');
            }
        }
    });
}

function validateTimeInput(element: JQuery, regex: RegExp) {
    element.kendoValidator({
        validationSummary: undefined,
        rules: {
            timeValidation: (input: JQuery<kendo.ui.ValidatorEvent>) => {
                const value = String(input.val());
                if (value) {
                    if (!regex.test(value)) {
                        // Очистка значения
                        input.data('kendoComboBox')?.value('');
                        return false;
                    }
                }
                return true;
            }
        },
        messages: {
            timeValidation: 'Неверное время'
        }
    });
}

function changeValueInDataPicker(changedInputDate: KendoDatePicker, isStartElement: boolean) {
    const [startElem, endElem] = isStartElement ? [this, changedInputDate] : [changedInputDate, this];

    if (startElem?.value()?.getTime() > endElem?.value()?.getTime()) {
        /** Если датапикер состоит только из "Месяц.Год" */
        if (this.options.format === 'MMMM yyyy') {
            const newStartDate = new Date(this.value().getFullYear(), this.value().getMonth());
            const newEndDate = new Date(this.value().getFullYear(), this.value().getMonth() + 1, 0, 23, 59, 59);

            startElem.value(newStartDate);
            endElem.value(newEndDate);
            /** Если датапикер состоит только из "День.Месяц.Год Часы.Минуты" */
        }
        else {
            changedInputDate.value(new Date(this.value()));
        }
    }
}

function datePeriodOnChange() {
    $('[data-group-dates]').each((_, elem) => {
        const [startTimeElem, endTimeElem] = $(elem).find('.k-datetimepicker, .k-datepicker');

        const getKendoDateTimePicker = (el: HTMLElement): KendoDatePicker | undefined =>
            $(el).find('input').data($(el).hasClass('k-datepicker') ? 'kendoDatePicker' : 'kendoDateTimePicker');

        const startInputData = getKendoDateTimePicker(startTimeElem);
        const endInputData = getKendoDateTimePicker(endTimeElem);

        startInputData?.bind('change', function () {
            changeValueInDataPicker.call(this, endInputData, true);
        });

        endInputData?.bind('change', function () {
            changeValueInDataPicker.call(this, startInputData, false);
        });
    });
}

window.datePeriodOnChange = datePeriodOnChange;
window.validateTimeInput = validateTimeInput;
window.validateDateInput = validateDateInput;
window.changeKendoDatePicker = changeKendoDatePicker;
window.updateDtEndForCalculationRequest = updateDtEndForCalculationRequest;
window.changeValueInDataPicker = changeValueInDataPicker;
